import { ChangeDetectionStrategy, Component, computed, input, OnInit } from '@angular/core';
import { HelperService } from '../../../services/helper.service';
import { E_DATE_FORMAT, E_FR_LOC } from '@shared/constants/enums.const';

@Component({
  selector: 'app-is-new-tag',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './is-new-tag.component.html',
  styleUrl: './is-new-tag.component.scss',
})
export class IsNewTagComponent implements OnInit {
  newsDate = input<any>();
  dateToShow = '';
  isToday = false;
  protected readonly E_DATE_FORMAT = E_DATE_FORMAT;
  protected readonly newStr = 'New';

  constructor(public HELPER: HelperService) {}

  isNotDE = computed<boolean>(() => {
    return this.HELPER.currentLang !== E_FR_LOC.de;
  });

  checkIsToday(dateToCheck: Date): boolean {
    const today = new Date();
    return dateToCheck.getDate() === today.getDate() &&
      dateToCheck.getMonth() === today.getMonth() &&
      dateToCheck.getFullYear() === today.getFullYear();
  }

  ngOnInit(): void {
    if (!this.newsDate()) {
      this.dateToShow = '';
      return;
    }


    this.isToday = this.checkIsToday(new Date(this.newsDate()));
    // Dont show 'New' on DE fr
    if (this.isToday && this.isNotDE()) {
      this.dateToShow = this.newStr;
    } else {
      this.dateToShow = new Date(this.newsDate()).toString();
    }

  }
}
